import {
  OPEN_LIST_SETTINGS_MODAL,
  CLOSE_LIST_SETTINGS_MODAL,
  OPEN_ADMIN_ROLES_MODAL,
  CLOSE_ADMIN_ROLES_MODAL,
  OPEN_ADMIN_USER_MODAL,
  CLOSE_ADMIN_USER_MODAL,
  OPEN_SMTP_SETUP_MODAL,
  CLOSE_SMTP_SETUP_MODAL,
  TOGGLE_ADMIN_MENU
} from '../../constants';
import { initialize } from 'redux-form';
import { censorEmail, decode } from '../../helpers/secureEmail';
import { formatLocaleData } from '../../helpers/formatLocale';

const openListSettingsModal = ({ ...initialData }, formName) => {

  return (dispatch, getState) => {

    const activeLanguageCodes = getState()?.runtime?.isActiveLanguages?.map(item => formatLocaleData(item)); 
    // or use formatLocaleData if needed

    let result;

    if (initialData?.dynamicItemName?.length > 0) {

      result = {
        ...initialData,
        dynamicItemName: initialData.dynamicItemName.map(item => ({
          ...item,
          language: activeLanguageCodes?.includes(item.language) ? item.language : '' 
        }))
      };

    } else {
      result = {
        ...initialData,
        dynamicItemName: [{
          itemName: initialData?.itemName,
          otherItemName: initialData?.otherItemName,
          itemDescription: initialData?.itemDescription,
          language: formName === 'EditListSettingsForm' ? 'en' : ''
        }]
      };

    }

    dispatch(initialize(formName, result, true));

    dispatch({
      type: OPEN_LIST_SETTINGS_MODAL,
      listSettingsModal: true,
    });

  };
};

const openEditListSettingsModal = (initialData) => {

  return (dispatch, getState) => {

    const activeLanguageCodes = getState()?.runtime?.isActiveLanguages?.map(item => formatLocaleData(item));

    const updatedData = {
      ...initialData,
      dynamicItemName: initialData?.dynamicItemName?.map(item => ({
        ...item,
        language: activeLanguageCodes?.includes(item.language) ? item.language : ''
      }))
    };

    dispatch(initialize("EditListSettingsForm", updatedData, true));

    dispatch({
      type: OPEN_LIST_SETTINGS_MODAL,
      listSettingsModal: true,
    });
  };
};

const closeListSettingsModal = () => {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_LIST_SETTINGS_MODAL,
      listSettingsModal: false
    });
  };
}


const openAdminRolesModal = (type, formData) => {
  return (dispatch, getState) => {
    if (type === 'edit') {
      dispatch(initialize("AdminRolesForm", formData, true));
    }

    dispatch({
      type: OPEN_ADMIN_ROLES_MODAL,
      payload: {
        adminRolesModal: true,
        adminRolesModalType: type,
        adminRolesModalData: formData
      }
    });
  }
}

const closeAdminRolesModal = () => {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_ADMIN_ROLES_MODAL,
      payload: {
        adminRolesModal: false
      }
    });
  }
}

const openAdminUserModal = (type, formData, isRestrict) => {
  return async (dispatch, getState) => {
    if (type === 'edit') {
      let encryptData = {
        email: isRestrict ? censorEmail(decode(formData.email)) : decode(formData.email),
        censorEmail: isRestrict ? censorEmail(decode(formData.email)) : decode(formData.email),
        encryptEmail: formData.email
      };
      formData = { ...formData, ...encryptData };
      await dispatch(initialize("AdminUserForm", formData, true));
    }

    dispatch({
      type: OPEN_ADMIN_USER_MODAL,
      payload: {
        adminUserModal: true,
        adminUserModalType: type,
        adminUserModalData: formData
      }
    });
  }
}

const closeAdminUserModal = () => {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_ADMIN_USER_MODAL,
      payload: {
        adminUserModal: false
      }
    });
  }
}

const openSmtpSetupModal = (type, formData) => {
  return (dispatch, getState) => {
    if (type === 'edit') {
      dispatch(initialize("SmtpForm", formData, true));
    }
    dispatch({
      type: OPEN_SMTP_SETUP_MODAL,
      payload: {
        smtpSetupModal: true,
        smtpSetupModalType: type,
        smtpSetupModalData: formData
      }
    });
  }
}

const closeSmtpSetupModal = () => {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_SMTP_SETUP_MODAL,
      payload: {
        smtpSetupModal: false
      }
    });
  }
}

const toggleAdminMenu = (isOpenAdminMenu) => {
  return (dispatch, getState) => {
    if (isOpenAdminMenu) {
      document.body.classList.add('sideMenuBodyHidden');
    } else {
      document.body.classList.remove('sideMenuBodyHidden');
    }
    dispatch({
      type: TOGGLE_ADMIN_MENU,
      payload: {
        isOpenAdminMenu,
      },
    });
  }
}

export {
  openListSettingsModal, openEditListSettingsModal, closeListSettingsModal,
  openAdminRolesModal, closeAdminRolesModal, openAdminUserModal, closeAdminUserModal, openSmtpSetupModal,
  closeSmtpSetupModal, toggleAdminMenu
};